import { EMOTIONS_COLORS_ARRAY, EMOTIONS_COLOR_GREY } from "../constants";

class EmotionHelper { }

EmotionHelper.getEmotionColor = (emotion_id) => {
    return (EMOTIONS_COLORS_ARRAY.hasOwnProperty(emotion_id)) ? EMOTIONS_COLORS_ARRAY[emotion_id] : EMOTIONS_COLOR_GREY;
}
export default EmotionHelper;